import styles from "../../../styles/Home.module.css";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import Image from "next/image";
import EmptyStateImage from "../../../assets/Illustrations/stack empty state.svg";
import AddUserImage from "../../../assets/Illustrations/add-person 1.svg";

import Link from "next/link";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import verifiedImage from "../../../assets/Illustrations/verified.png";
import { callBackendApi } from "@/utils/common";
import HeadComponent from "@/components/HeadComponent";
import Avatar from "react-avatar";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdClose } from "react-icons/md";
import { ImEmbed2 } from "react-icons/im";
import ImageCompanyLogo from "../../../components/ImageCompanyLogo";

const Stack = (props) => {
  const [stackInfo, setStackInfo] = useState();
  const [dataStack, setDataStack] = useState([]);
  const [allDataStack, setAllDataStack] = useState([]);
  const [stackLength, setStackLength] = useState();
  const [stackMembers, setStackMembers] = useState([]);
  const embedInput = useRef();
  const [copiedSuccess, setCopiedSuccess] = useState(false);
  const [showEmbedModal, setShowEmbedModal] = useState(false);

  const handleShowEmbedModal = () => {
    setShowEmbedModal(true);
  };
  const handleHideEmbedModal = () => {
    setShowEmbedModal(false);
  };

  const handleCopyEmbed = () => {
    const embedInputEl = embedInput.current;
    embedInputEl.select();
    embedInputEl.setSelectionRange(0, 99999);
    navigator.clipboard.writeText(embedInputEl.value);
    embedInputEl.blur();
    setCopiedSuccess(true);
    setTimeout(() => {
      setCopiedSuccess(false);
      handleHideEmbedModal();
    }, 1000);
  };

  useEffect(() => {
    setStackInfo(props.stack);
    setDataStack(props.dataStack);
    setStackLength(props.dataStack.length);
    setAllDataStack(props.allStacks);
    setStackMembers(props.stackMembers);
  }, [props]);

  const trackClick = (event) => {
    window.analytics.track(`stacks.${event}_clicked`);
  };

  const renderVerified = (props) => <Tooltip {...props}>Verified</Tooltip>;
  const renderMember = (props) => <Tooltip {...props}>{props}</Tooltip>;

  const metaTitle = `${
    props.stack && props.stack.companyName
  }- Modern Data Stack`;
  const metaDescription = `Check out the data stack of ${
    props.stack && props.stack.companyName
  }.${props.stack.description} `;

  const BaseUrl = {
    Development: "https://development.moderndatastack.xyz",
    Staging: "https://staging.moderndatastack.xyz",
    Production: "https://www.moderndatastack.xyz",
  };

  var iframeRef = `<iframe  src='${
    BaseUrl[`${process.env.NEXT_PUBLIC_app_env}`]
  }/embed/stacks/${stackInfo?.slug}' width="100%" height="500" />`;

  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: "#fff7ea",
      }}
    >
      <HeadComponent title={metaTitle} description={metaDescription} />
      {stackInfo && Object.keys(stackInfo).length > 0 && (
        <>
          <div className="mds-bg-primary-muted">
            <div className="container d-none d-lg-block">
              <nav className="py-3">
                <ol className="breadcrumb mds-breadcrumb">
                  <li className="breadcrumb-item">
                    <Link href="/stacks">
                      <a>Stacks</a>
                    </Link>
                  </li>
                  <li className="breadcrumb-item active text-capitalize" aria-current="page">
                    {stackInfo.companyName}
                  </li>
                </ol>
              </nav>
            </div>
            <Container className="pb-5">
              <Row className="justify-content-start">
                <Col sm={8} md={8} lg={10} xs={12}>
                  <Row className="justify-content-start">
                    <Col
                      id="stackName"
                      md={10}
                      xs={12}
                      className="justify-content-start"
                    >
                      {stackInfo.verified === true ? (
                        <h1
                          className="mt-1 ml-1 text-capitalize"
                          style={{ display: "inline-block" }}
                        >
                          {stackInfo.companyName}{" "}
                          <span>
                            <OverlayTrigger
                              trigger="hover"
                              placement="top"
                              rootClose
                              overlay={renderVerified}
                            >
                              <Image
                                src={verifiedImage}
                                alt=""
                                width={40}
                                height={40}
                              />
                            </OverlayTrigger>
                          </span>{" "}
                        </h1>
                      ) : (
                        <h1 className="text-capitalize">{stackInfo.companyName}</h1>
                      )}
                    </Col>
                    {props.width < 575 && (
                      <Col
                        sm={4}
                        md={4}
                        lg={4}
                        xs={12}
                        style={{
                          display: "flex",
                          justifyContent: props.width < 575 ? "center" : "end",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "white",
                            color: "#f77855",
                            borderRadius: "50%",
                            maxHeight: "150px",
                            maxWidth: "150px",
                            minHeight: "150px",
                            minWidth: "150px",
                            display: "table",
                            textAlign: "end",
                          }}
                        >
                          {stackInfo.companyLogo != "null" &&
                          stackInfo.companyLogo != null ? (
                            <img
                              className=""
                              width="150px"
                              height="150px"
                              src={stackInfo.companyLogo}
                              alt=""
                              style={{ borderRadius: "50%" }}
                            />
                          ) : stackInfo.url.includes("ibm") &&
                            stackInfo.companyLogo === "null" &&
                            stackInfo.companyLogo === null ? (
                            <img
                              className=""
                              width="150px"
                              height="150px"
                              src="https://logo.clearbit.com/ibm.com"
                              alt=""
                              style={{ borderRadius: "50%" }}
                            />
                          ) : stackInfo.url.includes("google") &&
                            stackInfo.companyLogo === "null" &&
                            stackInfo.companyLogo === null ? (
                            <img
                              className=""
                              width="150px"
                              height="150px"
                              src="https://logo.clearbit.com/google.com"
                              alt=""
                              style={{ borderRadius: "50%" }}
                            />
                          ) : stackInfo.url.includes("github") &&
                            stackInfo.companyLogo === "null" &&
                            stackInfo.companyLogo === null ? (
                            <img
                              className=""
                              width="150px"
                              height="150px"
                              src="https://logo.clearbit.com/github.com"
                              alt=""
                              style={{ borderRadius: "50%" }}
                            />
                          ) : (
                            <img
                              height="150px"
                              width="150px"
                              src={`https://logo.clearbit.com/google.com/${stackInfo.url}`}
                              alt=""
                              style={{ borderRadius: "50%" }}
                            />
                          )}
                        </div>
                      </Col>
                    )}
                    <Col md={12} xs={12}>
                      <p
                        className="text-muted"
                        style={{ textAlign: "start", fontSize: "18px" }}
                      >
                        {stackInfo.description}
                        <span>
                          <a
                            style={{
                              color: "#f66640",
                              fontSize: "17px",
                              marginLeft: "7px",
                            }}
                            href={
                              stackInfo.url.indexOf("http://") == 0 ||
                              stackInfo.url.indexOf("https://") == 0
                                ? stackInfo.url
                                : `https://${stackInfo.url}`
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            Visit Website
                          </a>
                        </span>
                      </p>
                      <div className="">
                        <OverlayTrigger
                          placement="right"
                          overlay={
                            <Tooltip>Embed this stack in your page.</Tooltip>
                          }
                        >
                          <button
                            onClick={handleShowEmbedModal}
                            className="btn mds-btn-outline-primary-light d-flex align-items-center gap-2"
                          >
                            <ImEmbed2 />
                            <span className="mds-fw-md">Embed</span>
                          </button>
                        </OverlayTrigger>
                      </div>
                    </Col>
                  </Row>
                </Col>
                {props.width > 575 && (
                  <Col
                    sm={4}
                    md={4}
                    lg={2}
                    style={{
                      display: "flex",
                      justifyContent: props.width < 575 ? "center" : "end",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "white",
                        color: "#f77855",
                        borderRadius: "50%",
                        maxHeight: "150px",
                        maxWidth: "150px",
                        minHeight: "150px",
                        minWidth: "150px",
                        display: "table",
                        textAlign: "end",
                      }}
                    >
                      {stackInfo.companyLogo != "null" &&
                      stackInfo.companyLogo != null ? (
                        <img
                          className=""
                          width="150px"
                          height="150px"
                          src={stackInfo.companyLogo}
                          alt=""
                          style={{ borderRadius: "50%" }}
                        />
                      ) : stackInfo.url.includes("ibm") &&
                        stackInfo.companyLogo === "null" &&
                        stackInfo.companyLogo === null ? (
                        <img
                          className=""
                          width="150px"
                          height="150px"
                          src="https://logo.clearbit.com/ibm.com"
                          alt=""
                          style={{ borderRadius: "50%" }}
                        />
                      ) : stackInfo.url.includes("google") &&
                        stackInfo.companyLogo === "null" &&
                        stackInfo.companyLogo === null ? (
                        <img
                          className=""
                          width="150px"
                          height="150px"
                          src="https://logo.clearbit.com/google.com"
                          alt=""
                          style={{ borderRadius: "50%" }}
                        />
                      ) : stackInfo.url.includes("github") &&
                        stackInfo.companyLogo === "null" &&
                        stackInfo.companyLogo === null ? (
                        <img
                          className=""
                          width="150px"
                          height="150px"
                          src="https://logo.clearbit.com/github.com"
                          alt=""
                          style={{ borderRadius: "50%" }}
                        />
                      ) : (
                        <img
                          height="150px"
                          width="150px"
                          src={`https://logo.clearbit.com/google.com/${stackInfo.url}`}
                          alt=""
                          style={{ borderRadius: "50%" }}
                        />
                      )}
                    </div>
                  </Col>
                )}
              </Row>
            </Container>
          </div>

          <Container className="justify-content-md-center my-3 py-5">
            <Row>
              <Col xs={12} sm={12} lg={12} xl={8} xxl={8} className="">
                {dataStack.length > 0 ? (
                  <div
                    style={{
                      border: "1px solid #FDE0D9",
                      borderRadius: "10px",
                    }}
                  >
                    {dataStack.map((data, index) => (
                      <Row className="p-3" key={data.group}>
                        <Col
                          md={12}
                          xl={12}
                          lg={12}
                          sm={12}
                          xs={12}
                          style={{ display: "flex", justifyContent: "start" }}
                          className="my-auto"
                        >
                          <h4
                            id={"categoryName" + index}
                            style={{ textAlign: "center" }}
                          >
                            {data.group}
                          </h4>
                        </Col>
                        {data.children.map((child, vendorIndex) => (
                          <Col
                            key={child.company.slug}
                            md={3}
                            xl={2}
                            lg={3}
                            sm={3}
                            xs={4}
                            xxl={2}
                            className="my-auto mt-2"
                          >
                            <Link
                              href="/company/[id]"
                              as={`/company/${child.company.slug}`}
                            >
                              <a
                                id={"vendorName" + index + vendorIndex}
                                style={{ textDecoration: "none" }}
                              >
                                <div
                                  style={{
                                    borderRadius: "50%",
                                    maxHeight: "30px",
                                    maxWidth: "35px",
                                    minHeight: "30px",
                                    minWidth: "35px",
                                    display: "table",
                                    margin: "auto",
                                    textAlign: "center",
                                  }}
                                >
                                  <ImageCompanyLogo
                                    width={50}
                                    height={50}
                                    company={child.company}
                                    className="rounded-circle"
                                  />
                                </div>
                                <div
                                  style={{ textAlign: "center" }}
                                  className="mt-1"
                                >
                                  <p className="text-capitalize" style={{ color: "#f66640" }}>
                                    {child.company.companyName}
                                  </p>
                                </div>
                              </a>
                            </Link>
                          </Col>
                        ))}
                        {index + 1 !== stackLength && (
                          <Col
                            md={12}
                            xl={12}
                            xxl={12}
                            style={{ display: "flex", justifyContent: "start" }}
                            className="my-auto"
                          >
                            <hr
                              className="mt-1 pb-0 mb-0"
                              style={{
                                width: "100%",
                                borderTop: "1px solid #F66640",
                                opacity: "0.2",
                                textAlign: "center",
                              }}
                            />
                          </Col>
                        )}
                      </Row>
                    ))}
                  </div>
                ) : (
                  <div
                    style={{
                      border: "1px solid #f66640",
                      borderRadius: "10px",
                    }}
                  >
                    <Row className="p-3 justify-content-center">
                      <Col
                        md={12}
                        sm={12}
                        xl={12}
                        xxl={12}
                        style={{ display: "flex", justifyContent: "center" }}
                      >
                        <img width="400px" src="/newsletter bw 1.svg" alt="" />
                      </Col>
                      <Col
                        md={12}
                        xl={12}
                        xxl={12}
                        style={{ display: "flex", justifyContent: "center" }}
                        className="my-auto"
                      >
                        <p
                          className="text-muted mt-0 pt-0"
                          style={{ textAlign: "center" }}
                        >
                          No data stack added yet !
                        </p>
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>

              <Col sm={12} xs={12} md={12} xl={4} xxl={4} lg={12}>
                <Row className="pt-3 pt-xl-0">
                  <Col xl={12} md={6} xs={12} lg={6} sm={12} className="mb-3">
                    <div
                      style={{
                        border: "1px solid #FDE0D9",
                        borderRadius: "10px",
                      }}
                    >
                      <Row className="p-3 justify-content-center">
                        <Col
                          md={12}
                          xl={12}
                          xxl={12}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                          className="my-auto"
                        >
                          <h4 className="m-0 mb-3">Members</h4>
                          {/* <Image src={AddUserImage} /> */}
                        </Col>
                        {stackMembers.length > 0 ? (
                          <div>
                            <div className="row row-cols-4 g-3">
                              {stackMembers.slice(0, 6).map((item, index) => {
                                return (
                                  <div key={index} className="col">
                                    <Link href={`/u/${item.username}`}>
                                      <a className="mds-text-primary">
                                        <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                                          <span>
                                            {item.imageUrl ? (
                                              <Image
                                                layout="fixed"
                                                className="border mds-border-primary-light rounded-circle"
                                                src={item.imageUrl}
                                                width={30}
                                                height={30}
                                                alt={item.fullName}
                                              />
                                            ) : (
                                              <Avatar
                                                name={item.fullName}
                                                size={30}
                                                round
                                              />
                                            )}
                                          </span>
                                          <span className="text-center mds-fs-sm">
                                            {item.fullName}
                                          </span>
                                        </div>
                                      </a>
                                    </Link>
                                  </div>
                                );
                              })}
                            </div>
                            {stackMembers.length > 6 && (
                              <div className="d-flex justify-content-start gap-2">
                                {stackMembers
                                  .slice(6, 12)
                                  .map((item, index) => {
                                    return (
                                      <div key={index}>
                                        This
                                        {item.imageUrl ? (
                                          <Image
                                            layout="fixed"
                                            className="border mds-border-primary-light rounded-circle"
                                            src={item.imageUrl}
                                            width={40}
                                            height={40}
                                          />
                                        ) : (
                                          <Avatar
                                            name={item.fullName}
                                            size={40}
                                            round
                                          />
                                        )}
                                        {item.fullName}
                                      </div>
                                    );
                                  })}
                              </div>
                            )}
                          </div>
                        ) : (
                          <>
                            <Col
                              md={6}
                              sm={12}
                              xl={12}
                              xxl={12}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Row
                                md={12}
                                xl={12}
                                xxl={12}
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                                className="my-auto"
                              >
                                <Image src={EmptyStateImage} />
                                <p
                                  className="text-muted mt-0 pt-0"
                                  style={{ textAlign: "center" }}
                                >
                                  No members found
                                </p>
                              </Row>
                            </Col>
                          </>
                        )}
                      </Row>
                    </div>
                  </Col>

                  {/* similar stacks */}
                  <Col xl={12} md={6} xs={12} lg={6} sm={12}>
                    <div
                      style={{
                        border: "1px solid #FDE0D9",
                        borderRadius: "10px",
                      }}
                    >
                      <Row className="p-3 justify-content-center">
                        <Col
                          md={12}
                          xl={12}
                          xxl={12}
                          style={{ display: "flex", justifyContent: "start" }}
                          className="my-auto"
                        >
                          <h4 style={{ textAlign: "center" }}>
                            Similar Stacks
                          </h4>
                        </Col>
                      </Row>
                      {allDataStack.map((item) => (
                        <Link
                          key={item.slug}
                          href="/stacks/[id]"
                          as={`/stacks/${item.slug}`}
                        >
                          <a
                            className={styles.card}
                            onClick={() => trackClick(item.slug)}
                          >
                            <Row
                              key={item.slug}
                              style={{
                                paddingLeft: "20px",
                                marginRight: "10px",
                              }}
                              className="justify-content-start pb-5"
                            >
                              <Col
                                md={2}
                                sm={2}
                                xs={2}
                                xl={2}
                                style={{ bordeRadius: "50%" }}
                                lg={2}
                              >
                                <div
                                  style={{
                                    borderRadius: "50%",
                                    maxHeight: "30px",
                                    maxWidth: "35px",
                                    minHeight: "30px",
                                    minWidth: "35px",
                                    display: "table",
                                    margin: "auto",
                                    textAlign: "center",
                                  }}
                                >
                                  <ImageCompanyLogo
                                    width={72}
                                    height={72}
                                    company={item}
                                    className="rounded-circle"
                                  />
                                </div>
                              </Col>
                              <Col md={10} sm={10} xs={10} xl={10} lg={10}>
                                <Row style={{ marginLeft: "5px" }}>
                                  <Col md={12} xl={12} xxl={12}>
                                    <h6
                                      className="mb-0 pb-2 text-capitalize"
                                      style={{
                                        textAlign: "start",
                                        fontSize: "18px",
                                      }}
                                    >
                                      {item.companyName}
                                    </h6>
                                  </Col>
                                  <Col md={12} xl={12} xxl={12}>
                                    <h6
                                      className="text-muted mt-0 pt-0"
                                      style={{ textAlign: "start" }}
                                    >
                                      {item.description.slice(0, 50)}...
                                    </h6>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </a>
                        </Link>
                      ))}
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
          <Modal
            className="mt-5"
            contentClassName="mds-rounded border-0 bg-transparent"
            show={showEmbedModal}
            onHide={handleHideEmbedModal}
          >
            <Modal.Body
              className="m-0 mds-rounded mds-border-primary-light mx-auto mds-modal-shadow"
              style={{
                width: "400px",
                backgroundColor: "#fff7ea",
              }}
            >
              <div className="d-flex justify-content-center align-items-center mb-3">
                <h5 className="m-0">Embed Stack</h5>
                <button
                  onClick={handleHideEmbedModal}
                  className="btn d-none p-0 px-1 mds-text-primary mds-bg-primary-muted"
                >
                  <MdClose />
                </button>
              </div>
              <div className=" mb-3">
                <textarea
                  disabled={true}
                  ref={embedInput}
                  rows={4}
                  className="form-control mds-border-primary-light mds-text-secondary mds-bg-primary-muted"
                >
                  {iframeRef}
                </textarea>
              </div>
              <div className="d-grid">
                <button
                  onClick={handleCopyEmbed}
                  className={
                    "btn btn-sm mds-btn-outline-primary-light mds-fw-md " +
                    (copiedSuccess && " active ")
                  }
                >
                  {copiedSuccess ? "Copied!" : "Copy Code"}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </div>
  );
};

export default Stack;
export const getServerSideProps = async (context) => {
  const allStacksRef = await callBackendApi({
    method: "get",
    url: "/stacks",
    params: { limit: 4 },
  });
  const stackData = await callBackendApi({
    method: "get",
    url: `/stacks/${context.query.id.toLowerCase()}`,
    params: {
      includeVendors: true,
      vendorsFields: "companyName slug companyLogo url",
      includeVendorsCategories: true,
      includeVendorsCategoriesFields: "name",
      includeMembers: true,
    },
  });

  const stacks = stackData.data.data;

  const stackMembersRef = await callBackendApi({
    method: "get",
    url: `/stacks/members/${stacks._id}`,
    params: { limit: 20 },
  });

  const stackMembers = stackMembersRef.data.data;

  let finaldata = [];
  let array = stacks.vendors.map((company) => {
    company.categories.map((categoryID) => {
      finaldata.push({ catetory: categoryID.name, company: company });
    });
  });

  let data = finaldata.reduce((r, e) => {
    // get first letter of name of current element
    let group = e.catetory;
    // if there is no property in accumulator with this letter create it
    if (!r[group]) r[group] = { group, children: [e] };
    // if there is push current element to children array for that letter
    else r[group].children.push(e);
    // return accumulator
    return r;
  }, {});
  let result = Object.values(data);

  return {
    props: {
      allStacks: allStacksRef.data.data,
      dataStack: result,
      stack: stacks,
      stackMembers,
    },
  };
};
